// src/config/loader.js
let CONFIG = null;

async function fetchJson(url) {
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} für ${url}`);
  }
  // Body erst als Text holen, damit Parse-Fehler sichtbar werden
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    console.error(`JSON-Parse-Fehler bei ${url}:`);
    throw new Error(`Ungültiges JSON in ${url}: ${e.message}`);
  }
}

export async function loadConfig() {
  if (CONFIG) return CONFIG;

  const tries = [
    '/api/_tenant.json',          // per Nginx pro Subdomain
    '/config/config.json',    // Fallback: aus public/config/
  ];

  let lastErr = null;
  for (const url of tries) {
    try {
      const cfg = await fetchJson(url);

      // Optional: Theme-Variablen & Favicon setzen
      if (cfg.theme) {
        Object.entries(cfg.theme).forEach(([k, v]) =>
          document.documentElement.style.setProperty(`--${k}`, String(v))
        );
      }
      if (cfg.favicon) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
        link.href = cfg.favicon;
      }

      CONFIG = cfg;
      return CONFIG;
    } catch (err) {
      console.warn(`[config] fehlgeschlagen bei ${url}:`, err.message);
      lastErr = err;
    }
  }

  throw new Error(lastErr ? lastErr.message : 'Keine Config gefunden');
}

export function getConfig() {
  if (!CONFIG) throw new Error('Config wurde noch nicht geladen');
  return CONFIG;
}